<template>
  <div>
    <span class="caption grey--text text--darken-1">{{ label }}</span>
    <v-combobox
      ref="combobox"
      :items="items"
      v-model="val"
      :multiple="isMultiple"
      small-chips
      @change="clearInput()"
      @update:searchInput="showAddbtn()"
      solo
      class="thin-border"
    >
      <v-btn
        @click="addItem"
        small
        color="primary"
        v-if="isAddBtnVisible"
        slot="append-outer"
        icon
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-combobox>
  </div>
</template>

<script>
export default {
  props: {
    value: { default: '' },
    componentId: { type: String },
    label: { type: String, default: '' },
    isMultiple: { type: Boolean },
    options: { type: Array }
  },
  data() {
    return {
      isAddBtnVisible: false
    }
  },
  computed: {
    val: {
      get() {
        // TODO: migrate to fix datastructure of changed hintfields, such as
        // intervention-motive in anesthesiology logbook
        if (this.isMultiple && typeof this.value === 'string') {
          return this.value.length > 0 ? [this.value] : undefined
        } else {
          return this.value
        }
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    items() {
      const options = this.options.map(o => o.text)

      const logOptions = this.$store.getters.logs
        .map(l => this.optionToString(l[this.componentId]))
        .flat()
        .filter(Boolean)

      return [...new Set([...options, ...logOptions])]
    }
  },
  methods: {
    addItem() {
      if (this.isMultiple) {
        const currentVal = this.$refs.combobox.initialValue
        const newVal = this.$refs.combobox.internalSearch
        this.$refs.combobox.setValue([...currentVal, newVal])
      } else {
        this.addSingleItem()
      }
    },
    addSingleItem() {
      const newVal = this.$refs.combobox.internalSearch
      this.$refs.combobox.setValue(newVal)
    },
    showAddbtn() {
      if (
        this.$refs.combobox &&
        this.$refs.combobox.internalSearch &&
        this.$refs.combobox.internalSearch.length > 2
      ) {
        this.isAddBtnVisible = true
      } else {
        this.isAddBtnVisible = false
      }
    },
    clearInput() {
      if (this.isMultiple) {
        setTimeout(() => {
          this.$refs.combobox.internalSearch = ''
        }, 500)
      }
    },
    optionToString(option) {
      if (Array.isArray(option)) {
        const options = []
        for (const o of option) {
          options.push(this.optionToString(o))
        }
        return options
      }

      if (option && typeof option === 'object') {
        return option.text || option.value || option.id
      }

      return option
    }
  }
}
</script>
